export const ButtonState = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SECONDARYINVERSE: "secondaryInverse",
  TERTIARY: "tertiary",
  BLUE: "primaryBlue",
  LIGHTBLUE: "lightPrimaryBlue",
  TERTIARY_INVERSE: "tertiaryInverse",
  TERTIARY_NONE: "tertiaryNone",
};

// export { ButtonState };